import React from "react";
import { ThemeProvider, createGlobalStyle, css } from "styled-components";
import reset from "styled-reset";
import "slick-carousel/slick/slick.css";
import BrandContext from "./contexts/BrandContext";
import { BreakpointContextProvider } from "./contexts/BreakpointContext";
import { GlobalFontSizeProvider } from "./contexts/GlobalFontSizeContext";
import LinkComponentContext from "./contexts/LinkComponentContext";
import useDeviceDetect from "./hooks/useDeviceDetect";
import { defaultBreakpoint } from "./settings";
import setGlobalVariable from "./utils/setGlobalVariable";
var defaultProps = {
  env: "development",
  ssrBreakpointValue: defaultBreakpoint
};

/**
 * 1. Needed for correct display of slick-slider (https://github.com/kenwheeler/slick/issues/982#issuecomment-73517458)
 * */
var GlobalStyles = createGlobalStyle(function (_ref) {
  var $isChromeBrowser = _ref.$isChromeBrowser,
    theme = _ref.theme;
  return css(["", ";*{min-width:0;min-height:0;font-family:inherit;&,&::before,&::after{box-sizing:border-box;}}html,body{overflow-x:initial;}body{font-family:", ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;}img{display:block;max-width:100%;}strong{font-weight:bold;}:focus{outline:#1989f6 solid 3px;outline-offset:2px;", "}:focus:not(:focus-visible){outline:none !important;}"], reset, theme.fontFamily.name, $isChromeBrowser ? css(["outline:", " auto 1px;"], theme.colors.backgroundBlack.color) : null);
});
function Hel(_ref2) {
  var brand = _ref2.brand,
    _ref2$env = _ref2.env,
    env = _ref2$env === void 0 ? defaultProps.env : _ref2$env,
    theme = _ref2.theme,
    _ref2$ssrBreakpointVa = _ref2.ssrBreakpointValue,
    ssrBreakpointValue = _ref2$ssrBreakpointVa === void 0 ? defaultProps.ssrBreakpointValue : _ref2$ssrBreakpointVa,
    linkComponent = _ref2.linkComponent,
    disableFontSizeProvider = _ref2.disableFontSizeProvider,
    children = _ref2.children;
  var _useDeviceDetect = useDeviceDetect(),
    isChromeBrowser = _useDeviceDetect.isChromeBrowser;
  setGlobalVariable("env", env);
  var HelElement = /*#__PURE__*/React.createElement(BrandContext.Provider, {
    value: brand
  }, /*#__PURE__*/React.createElement(BreakpointContextProvider, {
    initialBreakpoint: ssrBreakpointValue
  }, /*#__PURE__*/React.createElement(LinkComponentContext.Provider, {
    value: linkComponent
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GlobalStyles, {
    $isChromeBrowser: isChromeBrowser
  }), children)))));
  if (disableFontSizeProvider) {
    return HelElement;
  }
  return /*#__PURE__*/React.createElement(GlobalFontSizeProvider, null, HelElement);
}
export default Hel;